/* Proof Band (sections/proof-band.liquid)
   Counts numeric stat values up when the band scrolls into view.
   The markup always contains the final values; they are only replaced
   for the duration of the animation itself, so with JavaScript off,
   reduced motion on, the theme editor open, a hidden tab, or a
   non-numeric value ("Vegan", "GF") the real numbers stay visible. */
(function () {
  'use strict';

  if (customElements.get('wolf-proof-band')) return;

  var DURATION = 1600;
  var VALUE_PATTERN = /^([^0-9]*)([0-9][0-9,]*(?:\.[0-9]+)?)(.*)$/;

  function easeOutQuad(t) {
    return t * (2 - t);
  }

  function groupThousands(text) {
    return text.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  class WolfProofBand extends HTMLElement {
    connectedCallback() {
      this.animated = false;
      this.frame = null;
      this.targets = [];

      // In the theme editor, on reduced motion, or without IO support the
      // markup's final values are simply left alone.
      if (window.Shopify && window.Shopify.designMode) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;

      var elements = Array.prototype.slice.call(this.querySelectorAll('[data-proof-value]'));
      elements.forEach(
        function (element) {
          var match = VALUE_PATTERN.exec(element.textContent.trim());
          if (!match) return;
          var target = parseFloat(match[2].replace(/,/g, ''));
          if (isNaN(target) || target === 0) return;
          this.targets.push({
            element: element,
            finalText: element.textContent.trim(),
            prefix: match[1],
            suffix: match[3],
            target: target,
            decimals: (match[2].split('.')[1] || '').length,
            grouped: match[2].indexOf(',') !== -1
          });
        }.bind(this)
      );

      if (this.targets.length === 0) return;

      this.observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              this.startAnimation();
              this.observer.disconnect();
              this.observer = null;
              break;
            }
          }
        }.bind(this),
        { threshold: 0.3 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      this.restoreFinalValues();
    }

    restoreFinalValues() {
      if (this.frame) {
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }
      this.targets.forEach(function (item) {
        item.element.textContent = item.finalText;
      });
    }

    formatValue(item, value) {
      var text = item.decimals > 0 ? value.toFixed(item.decimals) : String(Math.floor(value));
      if (item.grouped) text = groupThousands(text);
      return item.prefix + text + item.suffix;
    }

    startAnimation() {
      if (this.animated) return;
      this.animated = true;
      var startTime = performance.now();
      var self = this;

      var update = function (currentTime) {
        var progress = Math.min((currentTime - startTime) / DURATION, 1);
        var eased = easeOutQuad(progress);
        self.targets.forEach(function (item) {
          item.element.textContent =
            progress < 1 ? self.formatValue(item, eased * item.target) : item.finalText;
        });
        self.frame = progress < 1 ? requestAnimationFrame(update) : null;
      };
      this.frame = requestAnimationFrame(update);
    }
  }

  customElements.define('wolf-proof-band', WolfProofBand);
})();
